"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unitsOfAccount = exports.productTypes = exports.locations = void 0;

/**
 * Module dependencies.
 */

/**
 * Export `productTypes`.
 */
var productTypes = {
  asset: 'asset',
  digital: 'digital',
  fundraising: 'fundraising',
  physical: 'physical',
  service: 'service'
};
/**
 * Export `locations`.
 */

exports.productTypes = productTypes;
var locations = {
  inPerson: 'in_person',
  remote: 'remote'
};
/**
 * Export `unitsOfAccount`.
 */

exports.locations = locations;
var unitsOfAccount = {
  "class": 'class',
  day: 'day',
  event: 'event',
  hour: 'hour',
  job: 'job',
  monthly: 'monthly',
  other: 'other',
  session: 'session',
  weekly: 'weekly'
};
/**
 * Export `ProductType` type.
 */

exports.unitsOfAccount = unitsOfAccount;